import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import { checkLoggedIn } from '../store/actions/checkPermissions';
import { PERMISSION_STATUS } from '../constants/permissions';

import Spinner from '../components/common/Spinner';
import NoMatchContainer from '../containers/pages/NoMatchContainer';
import { ServerErrorContainer } from '../containers/pages/ServerErrorContainer';

function UserRequiredHOCWrapper(ComposedComponent) {
  function UserRequiredHOC(props) {
    const { status, isLoading, checkPermissions } = props;

    useEffect(() => {
      checkPermissions();
    }, [checkPermissions]);

    if (isLoading) {
      return <Spinner />;
    } else if (status === PERMISSION_STATUS.DENIED) {
      return <NoMatchContainer />;
    } else if (status === PERMISSION_STATUS.SERVER_ERROR) {
      return <ServerErrorContainer />;
    } else {
      return <ComposedComponent {...props} />;
    }
  }

  const mapStateToProps = ({ checkPermissions }) => {
    const { isLoading, status } = checkPermissions;

    return {
      isLoading,
      status,
    };
  };

  const mapDispatchToProps = (dispatch) => {
    return {
      checkPermissions: () => dispatch(checkLoggedIn()),
    };
  };

  UserRequiredHOC.defaultProps = {
    status: null,
    isLoading: true,
  };

  UserRequiredHOC.propTypes = {
    status: PropTypes.oneOf([null, PERMISSION_STATUS.DENIED, PERMISSION_STATUS.SERVER_ERROR]),
    isLoading: PropTypes.bool,
    checkPermissions: PropTypes.func.isRequired,
  };

  return connect(mapStateToProps, mapDispatchToProps)(UserRequiredHOC);
}

export default UserRequiredHOCWrapper;
